import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file

import React from 'react';
import { getServerSidePropsLoader, regroupModuleReducers, GetServerSidePropsReturn } from '@rakutenfrance/redux-apollo-helper';

import { mdModule } from '@rakutenfrance/breakpoint';
import { tolgeeModule } from '@rakutenfrance/tolgee-provider';
import addToCartMuiModule from '@rakutenfrance/add-to-cart-mui';
import '@rakutenfrance/add-to-cart-mui/build/style.global.css';

import { renderReact } from '../../fragmentHelper/renderReactCustom';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';

import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';

const { AddToCartMuiContainer } = addToCartMuiModule.containers;

const modules = [addToCartMuiModule, mdModule, tolgeeModule];
const reducers = regroupModuleReducers(modules);

export const serverCanCache = true;

const WrappedAddToCartModal: React.FC<PagePropsType> = ({ moduleName, initialApolloState, initialReduxState }) => {
  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      moduleName={moduleName}
      reducers={reducers}
    >
      <AddToCartMuiContainer />
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const renderFunction = renderReact('AddToCart', WrappedAddToCartModal);

export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext): Promise<GetServerSidePropsReturn> => {
  const baseUrl = null;
  const preloadedConfig = null;
  const graphQlVariables = {};
  const graphQlQuery = undefined;

  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );
  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};
